import * as React from "react";
import {useEffect, useState} from "react";
import {redirectToSetu} from "setu/api";
import Loading from "components/loading";

const Setu = () => {
    const [error, setError] = useState<string|null>(null);

    useEffect(() => {
        try {
            redirectToSetu();
        } catch (e) {
            setError(e.toString());
        }
    }, []);

    return (
        error
        ? <div className="error">
            Something went wrong!
            Looks like {error}
        </div>
        : <Loading active={true} msg={"Please wait"}/>
    );
};

export default Setu;
